import { TDynamicModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

export const sortByChecked = (options: TDynamicModalSelectOption) => {
	return options.slice().sort((a, b) => {
		if (a.isChecked === b.isChecked) {
			return 0;
		}
		return a.isChecked ? -1 : 1;
	});
};

export const sortByDefault = (options: TDynamicModalSelectOption) => {
	return options.slice().sort((a, b) => a.originalIndex - b.originalIndex);
};
